"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const common = {
  borderRadius: 8,
  indicatorBg: 'text.1',
  indicatorDimension: 16,
  offset: 0,
  progressBg: 'transparent'
};
const primary = { ...common,
  progressBg: 'interactive.primary.default',
  bg: 'background.tan',
  dimension: 4
};
const buySell = { ...common,
  progressBg: 'interactive.buy.default',
  bg: 'interactive.sell.default',
  dimension: 8,
  offset: 5
};
const static1 = { ...common,
  bg: 'background.yellow',
  dimension: 8,
  offset: 5
};
const static2 = { ...common,
  bg: 'background.brown',
  dimension: 8,
  offset: 5
};
const theme = {
  buySell,
  primary,
  static1,
  static2
};
exports.theme = theme;
//# sourceMappingURL=Progress.theme.js.map